<template>
  <el-dialog
    :title="this.ruleId === null ? '新增规则' : '编辑规则'"
    :visible.sync="dialogFormVisible"
    custom-class="custom_dialog"
    :close-on-click-modal="false"
  >
    <el-row>
      <el-col :span="22" :offset="1">
        <el-form
          :model="ruleForm"
          :rules="ruleFormRules"
          ref="ruleForm"
          label-width="130px"
          class="demo-ruleForm"
          size="mini"
          width="500px"
        >
          <el-form-item label="规则名称：" prop="Name">
            <el-input
              v-model="ruleForm.Name"
              autocomplete="off"
              placeholder="请输入规则名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="通过方式：" v-if="ruleType === 0" required>
            <el-select v-model="ruleForm.PassOperator" @change="$forceUpdate()">
              <el-option label=">=" value="0"></el-option>
              <el-option label=">" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通过率：" v-if="ruleType === 0" required>
            <el-col :span="7">
              <el-form-item
                class="el-form-item-internal"
                prop="PassValue_start"
              >
                <el-input-number
                  v-model="ruleForm.PassValue_start"
                  controls-position="right"
                  :precision="0"
                  :step="1"
                  :min="1"
                  :max="1000"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">/</el-col>
            <el-col :span="7">
              <el-form-item class="el-form-item-internal" prop="PassValue_end">
                <el-input-number
                  v-model="ruleForm.PassValue_end"
                  controls-position="right"
                  :precision="0"
                  :step="1"
                  :min="1"
                  :max="1000"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="去掉最高分：" v-if="ruleType === 2">
            <el-switch v-model="ruleForm.DeleteMaxScore"></el-switch>
          </el-form-item>
          <el-form-item label="去掉最低分：" v-if="ruleType === 2">
            <el-switch v-model="ruleForm.DeleteMinScore"></el-switch>
          </el-form-item>
          <el-form-item label="显示评委信息：" v-if="ruleType === 3">
            <el-switch v-model="ruleForm.IsAnony"></el-switch>
          </el-form-item>
          <el-form-item label="去掉最高分：" v-if="ruleType === 3">
            <el-switch v-model="ruleForm.IsRemoveMaxScore"></el-switch>
          </el-form-item>
          <el-form-item label="去掉最低分：" v-if="ruleType === 3">
            <el-switch v-model="ruleForm.IsRemoveMinScore"></el-switch>
          </el-form-item>
          <el-form-item label="是否分细项打分：" v-if="ruleType === 3">
            <el-switch v-model="ruleForm.IsDetailRule"></el-switch>
          </el-form-item>
          <el-form-item
            label="最低分数："
            v-if="ruleType === 3 && !ruleForm.IsDetailRule"
            prop="MinScore"
          >
            <el-input-number
              v-model="ruleForm.MinScore"
              controls-position="right"
              :min="0"
              size="mini"
              :precision="0"
              :step="1"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="最高分数："
            v-if="ruleType === 3 && !ruleForm.IsDetailRule"
            prop="MaxScore"
          >
            <el-input-number
              v-model="ruleForm.MaxScore"
              controls-position="right"
              :min="0"
              size="mini"
              :precision="0"
              :step="1"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="显示顺序：">
            <el-col :span="16">
              <el-form-item class="el-form-item-internal" prop="Sort">
                <el-input
                  v-model="ruleForm.Sort"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  :max="1000000"
                  autocomplete="off"
                  placeholder="请输入排序序号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveRule('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import voteRuleApi from '../../api/vote/voteRule'
export default {
  name: 'EditRule',
  data () {
    const _this = this
    const validateSort = (rule, value, callback) => {
      if (value >= 1000000) {
        callback(new Error('排序值必须小于7位数！'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        Id: null,
        Name: null,
        MeetId: null,
        Type: null,
        Sort: null,
        PassOperator: null,
        PassValue_start: null,
        PassValue_end: null,
        SelectNumber: null,
        DeleteMaxScore: false,
        DeleteMinScore: false,
        IsAnony: true,
        IsRemoveMaxScore: false,
        IsRemoveMinScore: false,
        IsDetailRule: false,
        MinScore: 0,
        MaxScore: 100
      },
      ruleFormRules: {
        Name: [
          { required: true, message: '请输入规则名称', trigger: 'blur' },
          { min: 1, max: 50, message: '名称长度最多50个字符。', trigger: 'blur' }],
        PassValue_start: [
          { required: true, message: '请输入通过率', trigger: 'blur' }],
        PassValue_end: [
          { required: true, message: '请输入通过率', trigger: 'blur' }],
        Sort: [
          { validator: validateSort, trigger: 'blur' }],
        MinScore: [
          { required: true, message: '请输入最低分数', trigger: 'blur' }],
        MaxScore: [
          { required: true, message: '请输入最高分数', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (_this.ruleForm.MinScore > value) {
                callback(new Error('最高分必须大于最低分！'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }]
      },
      dialogFormVisible: false,
      ruleId: null
    }
  },
  props: {
    // ruleId: { type: String },
    meetId: { type: String },
    ruleType: { type: Number },
    fatherSubmitDialog: {
      type: Function,
      default: null
    }
  },
  methods: {
    getRule: function () {
      voteRuleApi.getRule({
        ruleId: this.ruleId
      }).then(data => {
        this.ruleForm = data
        this.openLoading().close()
      }).catch(err => {
        this.openLoading().close()
        return err
      })
    },
    getScreenRule: function () {
      voteRuleApi.getScreenRule({
        ruleId: this.ruleId
      }).then(data => {
        this.ruleForm = data
        this.openLoading().close()
      }).catch(err => {
        this.openLoading().close()
        return err
      })
    },
    saveRule: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const openLoading = this.openLoading('保存中…')
          if (this.ruleForm.Type === 3) {
            voteRuleApi.editScreenRule(this.ruleForm).then(data => {
              openLoading.close()
              this.$message({
                showClose: true,
                type: 'success',
                message: '保存成功!',
                customClass: 'custom_message'
              })
              this.dialogFormVisible = false
              this.fatherSubmitDialog()
            }).catch(err => {
              openLoading.close()
              this.dialogFormVisible = false
              this.fatherSubmitDialog()
              return err
            })
          } else {
            voteRuleApi.editRule(this.ruleForm).then(data => {
              openLoading.close()
              this.$message({
                showClose: true,
                type: 'success',
                message: '保存成功!',
                customClass: 'custom_message'
              })
              this.dialogFormVisible = false
              this.fatherSubmitDialog()
            }).catch(err => {
              openLoading.close()
              this.dialogFormVisible = false
              this.fatherSubmitDialog()
              return err
            })
          }
        } else {
          return false
        }
      })
    },
    openEditRule: function (ruleId) {
      this.openLoading()
      this.dialogFormVisible = true
      this.ruleId = ruleId
      if (!ruleId) {
        this.ruleForm = {}
        this.ruleForm.MeetId = this.meetId
        this.ruleForm.Type = this.ruleType
        if (this.ruleType === 0) {
          this.ruleForm.PassOperator = '0'
        }
        if (this.ruleType === 3) {
          this.ruleForm.MinScore = 0
          this.ruleForm.MaxScore = 100
          this.ruleForm.IsAnony = true
        }
        this.openLoading().close()
      } else {
        if (this.ruleType === 3) {
          this.getScreenRule()
        } else {
          this.getRule()
        }
      }
    }
  },
  created () {

  }
}
</script>
<style lang="less">
.el-input-number--mini {
  width: auto;
}
</style>
